import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
	async getOrders(accessToken, client_id, range, start_date, end_date, limit, with_quantities, with_interval) {
	  let res = await axios.get(API_NAME + "/orders?client_id=" + client_id + '&range=' + range + '&start_date=' + start_date + '&end_date=' + end_date + '&limit=' + limit + '&with_quantities=' + with_quantities + '&with_interval=' + with_interval, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getOrdersForGarments(accessToken, client_id, range, start_date, end_date, limit, with_quantities, with_interval = '', garment_ids = []) {
	  let garmentFilter = ''
	  if (Array.isArray(garment_ids) && garment_ids.length > 0) {
		garmentFilter = '&garment_ids=' + garment_ids.join(',')
	  }
	  let res = await axios.get(API_NAME + "/orders?client_id=" + client_id + '&range=' + range + '&start_date=' + start_date + '&end_date=' + end_date + '&limit=' + limit + '&with_quantities=' + with_quantities + '&with_interval=' + with_interval + garmentFilter, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getGarments(accessToken) {
	  let res = await axios.get(API_NAME + "/garments", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getClients(accessToken, search = '') {
	  let searchParam = search ? '?search=' + encodeURIComponent(search) : ''
	  let res = await axios.get(API_NAME + "/oneills_clients" + searchParam, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getOrdersForClients(accessToken, start_date, end_date, client_ids = []) {
	  let clientFilter = ''
	  if (Array.isArray(client_ids) && client_ids.length > 0) {
		clientFilter = '&client_ids=' + client_ids.join(',')
	  }
	  let res = await axios.get(API_NAME + "/orders?start_date=" + start_date + '&end_date=' + end_date + '&with_quantities=1' + clientFilter, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getOrdersMadeUpOffshore(accessToken, start_date, end_date) {
		let res = await axios.get(API_NAME + "/orders/made_up_offshore?start_date=" + start_date + "&end_date=" + end_date, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
	async getGaaJerseyOrders(accessToken, start_date, end_date) {
		let res = await axios.get(API_NAME + "/orders/gaajerseys?start_date=" + start_date + "&end_date=" + end_date, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
	
  async getDesigns(accessToken,  start_date, end_date, clientLocationID) {
	let res = await axios.get(API_NAME + '/designs?start_date=' + start_date + '&end_date=' + end_date + '&clientLocationID=' + clientLocationID, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
  async getOrderByPONumber(accessToken, ponumber, area, all_areas, offshore) {
	let with_logs = 1
	let with_bundles = 1
	
	let printing_papers = 0
	let printing_saves = 0
	if(area == "paper")
	{
		printing_papers = 1
	}
	let printing_rolls = 0
	if(area == "rolls")
	{
		printing_rolls = 1
	}
	let cuttings = 0
	if(area == "cutting")
	{
		cuttings = 1
	}
	let multiply_cuttings = 0
	if(area == "multiply_cutting")
	{
		multiply_cuttings = 1
	}
	let cutsew_cuttings = 0
	if(area == "cutsew_cutting")
	{
		cutsew_cuttings = 1
		with_logs =0
		with_bundles = 0
	}
	if(area == "saving")
	{
		printing_saves = 1
	}

	if(area == "on_floor" || area == "off_floor" || area == "embroidery" || area == "silicon_stripes")
	{
		with_logs =0
		with_bundles = 0
	}

	if(all_areas == 1)
	{
		printing_papers = 1
		printing_rolls = 1
		cuttings = 1
		multiply_cuttings = 1
		cutsew_cuttings = 1
		printing_saves = 1
	}

	let makeup_logs = 0
	if(offshore == 1)
	{
		printing_papers = 0
		printing_rolls = 0
		cuttings = 0
		multiply_cuttings = 0
		cutsew_cuttings = 1
		printing_saves = 0
		makeup_logs = 1
	}

	if(area == "multiply_cutting" && offshore == 1)
	{
		multiply_cuttings = 1
	}
	
	let res = await axios.get(API_NAME + "/orders?ponumber=" + ponumber + "&with_logs=" + with_logs + "&with_bundles=" + with_bundles + "&with_printing_papers=" + printing_papers + "&with_printing_saves=" + printing_saves + "&with_printing_rolls=" + printing_rolls + "&with_cuttings=" + cuttings + "&with_multiply_cuttings=" + multiply_cuttings + "&with_cutsew_cuttings=" + cutsew_cuttings + "&with_makeup_logs=" + makeup_logs, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
	return res.data;
	},
  
  async getDigitalPrintOrders(accessToken, client_id, start_date, limit) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*' 
	
	let res = await axios.get(API_NAME + "/orders?client_id=" + client_id + '&printed=1&start_date=' + start_date + '&limit=' + limit + '&with_quantities=1&fields=' + selectFields, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getProductionIncomingOrders(accessToken, order_by , fully_printed, offshore, printed) {
	
	let res = await axios.get(API_NAME + "/orders/new-incoming?with_quantities=1&order_by=" + order_by + "&printed=" + printed + "&fully_printed=" + fully_printed + '&offshore=' + offshore, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getProductionMakeupAllocated(accessToken, order_by, makeup_location_id ) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,locations.name as makeup_location_name' 
	
	let res = await axios.get(API_NAME + "/orders/makeup_allocated?with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&makeup_location_id=" + makeup_location_id, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getOffshoreEmbroideryOrders(accessToken, order_by, embroidery_processed, in_production, sent_offshore, order_embroidery, start_date, end_date, with_embroidery_details ) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,locations.name as makeup_location_name' 
	
	let res = await axios.get(API_NAME + "/orders/offshore_embroidery?with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&order_embroidery=" + order_embroidery + "&embroidery_processed=" + embroidery_processed + "&in_production=" + in_production + "&sent_offshore=" + sent_offshore + "&start_date=" + start_date + "&end_date=" + end_date + "&with_embroidery_details=" + with_embroidery_details, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getOffshoreEmbroideryOrdersForStrabane(accessToken ) {
	let selectFields = 'orders.*,tblClients.clientname,locations.name as makeup_location_name' 
	
	let res = await axios.get(API_NAME + "/orders/offshore_embroidery_strabane?with_quantities=1&fields=" + selectFields, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  
  
  async getProductionOrdersToExport(accessToken, order_by ) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,locations.name as makeup_location_name' 
	
	let res = await axios.get(API_NAME + "/orders/ready_to_export?with_quantities=1&fields=" + selectFields + "&order_by=" + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getProductionOrdersToExportPlanner(accessToken, order_by ) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	//let selectFields = 'orders.*,tblClients.clientname,locations.name as makeup_location_name' 
	
	let res = await axios.get(API_NAME + "/orders/ready_to_export_planner?with_quantities=1&order_by=" + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  
  async getStrabaneIncomingOrders(accessToken, order_by, limit ) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,locations.name as makeup_location_name' 
	
	let res = await axios.get(API_NAME + "/orders?strabane_incoming=1&limit=" + limit + "&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getOffshoreInProgressOrders(accessToken, order_by, limit ) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,locations.name as makeup_location_name' 
	
	let res = await axios.get(API_NAME + "/orders?offshore_inprogress=1&limit=" + limit + "&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getOrdersWithKidsQuantities(accessToken, client_id, range_id, start_date, end_date, limit) {
	console.log(range_id)
	let res = await axios.get(API_NAME + "/orders?client_id=" + client_id + '&with_quantities=1&includes_kids_sizes=1&start_date=' + start_date + '&end_date=' + end_date + '&limit=' + limit, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
	return res.data;
	},
	async getOpenOrders(accessToken, order_by, start_date, end_date, exclude_socks, makeup_location_id, include_blanks, location) {
			
			let res = await axios.get(API_NAME + "/orders/open?order_by=" + order_by + '&start_date=' + start_date + '&end_date=' + end_date  + '&exclude_socks=' + exclude_socks + '&makeup_location_id=' + makeup_location_id+ '&include_blanks=' + include_blanks + '&location=' + location + "&exclude_hats=1", {
				headers: {
					Authorization: `Bearer ${accessToken}`
				}
				});
			return res.data;
	},
	async getAggregatedOpenOrders(accessToken) {
			
			let res = await axios.get(API_NAME + "/aggregated_open_orders", {
				headers: {
					Authorization: `Bearer ${accessToken}`
				}
				});
			return res.data;
	},
	async getAggregatedSockOrders(accessToken) {
			
			let res = await axios.get(API_NAME + "/aggregated_sock_orders", {
				headers: {
					Authorization: `Bearer ${accessToken}`
				}
				});
			return res.data;
	},
	
	async getAggregateTable(accessToken) {
		let res = await axios.get(API_NAME + "/aggregate_tables", {
				headers: {
					Authorization: `Bearer ${accessToken}`
				}
				});
			return res.data;
	},
	
	async getInternalOrders(accessToken, start_date, end_date) {
		
		let res = await axios.get(API_NAME + "/internal_orders?start_date=" + start_date + '&end_date=' + end_date, {
			  headers: {
				Authorization: `Bearer ${accessToken}`
			  }
			});
		return res.data;
		},
	async getMakeupDublinOrders(accessToken, start_date, end_date) {
		
			let res = await axios.get(API_NAME + "/orders/dublin-makeup?start_date=" + start_date + '&end_date=' + end_date, {
				  headers: {
					Authorization: `Bearer ${accessToken}`
				  }
				});
			return res.data;
	},
	async getMakeupStrabaneOrders(accessToken, start_date, end_date) {
		
		let res = await axios.get(API_NAME + "/orders/strabane-makeup?start_date=" + start_date + '&end_date=' + end_date, {
			  headers: {
				Authorization: `Bearer ${accessToken}`
			  }
			});
		return res.data;
},
	async getArtworksFinished(accessToken, start_date, end_date) {
		
		let res = await axios.get(API_NAME + "/reports/artworks_finished?start_date=" + start_date + '&end_date=' + end_date, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
	async getQCFinished(accessToken, start_date, end_date) {
		
		let res = await axios.get(API_NAME + "/reports/qc_finished?start_date=" + start_date + '&end_date=' + end_date, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
	async getRepeatArtworks(accessToken, start_date, end_date) {
		
		let res = await axios.get(API_NAME + "/reports/repeat_artworks?start_date=" + start_date + '&end_date=' + end_date, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
  async getIncomingArtworkOrders(accessToken, limit, order_by, count_only) {
	  let res = await axios.get(API_NAME + "/orders?printed=1&with_attachments=1&limit=" + limit + "&count_only=" + count_only + "&artwork_new=0&artwork_repeat=0&with_quantities=1&completed=0" + '&order_by=' + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getNewArtworkOrders(accessToken, limit, artworker_user_id, order_by, count_only) {
	  let res = await axios.get(API_NAME + "/orders?printed=1&limit=" + limit + "&count_only=" + count_only + "&artwork_new=1&artwork_finished=0&with_quantities=1&completed=0&artworker_user_id=" + artworker_user_id + '&order_by=' + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getQualityArtworkOrders(accessToken, limit, quality_user_id, order_by, count_only) {
	  let res = await axios.get(API_NAME + "/orders?printed=1&limit=" + limit + "&count_only=" + count_only + "&artwork_new=1&artwork_finished=1&artwork_quality_check=0&artwork_completed=0&with_quantities=1&quality_user_id=" + quality_user_id + '&order_by=' + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getQuality2ArtworkOrders(accessToken, limit, order_by, count_only) {
	let res = await axios.get(API_NAME + "/orders?printed=1&limit=" + limit + "&count_only=" + count_only + "&artwork_new=1&artwork_finished=1&artwork_quality_check=1&artwork_completed=0&with_quantities=1&order_by=" + order_by, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
  async getPrintingCuttingOrders(accessToken, print_location_id, limit, order_by, delivery_start_date, range_id, include_counts) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.designname,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf,tblDesigns.requires_knitted_trim,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	
	let res = await axios.get(API_NAME + "/orders?with_print_planner_notes=1&with_printing_papers=" + include_counts + "&with_printing_rolls=" + include_counts + "&with_cuttings=" + include_counts + "&restrict_by_print_location=1&range_id=" + range_id + "&limit=" + limit + "&printed=1&completed=0&ready_for_makeup=0&with_quantities=1&fields=" + selectFields + "&digital_print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + delivery_start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;

	// Removed &artwork_completed=1 on 30th April 2026 as per request from Mihaela
  },
   async getPrintingCuttingOrdersForOverview(accessToken, print_location_id, limit, order_by, delivery_start_date, range_id, include_counts) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.designname,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf,tblDesigns.requires_knitted_trim,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	console.log(include_counts)
	
	let res = await axios.get(API_NAME + "/orders?with_print_planner_notes=1&completed=0&restrict_by_print_location=1&range_id=" + range_id + "&limit=" + limit + "&printed=1&ready_for_makeup=0&with_quantities=1&fields=" + selectFields + "&digital_print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + delivery_start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;

	// Removed &artwork_completed=1 on 30th April 2026 as per request from Mihaela
  },
  async getPrintingPaperOrders(accessToken, print_location_id, limit,  order_by, start_date) {
	  let res = await axios.get(API_NAME + "/orders?completed=0&limit=" + limit + "&printed=1&artwork_completed=1&artwork_printed_paper=0&completed=0&with_quantities=1&print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getPrintingRollsOrders(accessToken, print_location_id, limit, order_by, start_date) {
	  let res = await axios.get(API_NAME + "/orders?completed=0&limit=" + limit + "&printed=1&artwork_completed=1&artwork_printed_paper=1&artwork_printed_rolls=0&with_quantities=1" + "&print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getPrintingRollsOrders2026(accessToken, print_location_id, limit, order_by, start_date) {
	  let res = await axios.get(API_NAME + "/orders?completed=0&limit=" + limit + "&printed=1&artwork_completed=1&artwork_printed_paper=1&artwork_printed_rolls=0&with_quantities=1" + "&fabric_print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getAllPrintingOrders(accessToken, print_location_id, limit, order_by, start_date) {
	let res = await axios.get(API_NAME + "/orders?completed=0&limit=" + limit + "&printed=1&artwork_completed=1&artwork_printed_rolls=0&with_quantities=1" + "&print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + start_date, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
  async getCuttingOrders(accessToken, print_location_id, limit, order_by, start_date) {
	  let res = await axios.get(API_NAME + "/orders?completed=0&limit=" + limit + "&printed=1&artwork_printed_rolls=1&digital_print_cutting=0&with_quantities=1" + "&print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
   async getCuttingOrders2026(accessToken, print_location_id, limit, order_by, start_date) {
	  let res = await axios.get(API_NAME + "/orders?completed=0limit=" + limit + "&printed=1&artwork_printed_rolls=1&digital_print_cutting=0&with_quantities=1" + "&fabric_print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + start_date , {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getMultiplyCuttingOrders(accessToken, makeup_location_id, limit, order_by, start_date) {
	let res = await axios.get(API_NAME + "/orders?limit=" + limit + "&cut_sew=1&multiply_cutting=0&with_quantities=1&completed=0&makeup_location_id=" + makeup_location_id + "&order_by=" + order_by + "&delivery_start_date=" + start_date, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
async getOffshoreMultiplyCuttingOrders(accessToken, makeup_location_id, limit, order_by, start_date) {
	let res = await axios.get(API_NAME + "/orders?limit=" + limit + "&part_printed=1&cutting_type_multi=1&multiply_cutting=0&with_quantities=1&completed=0&makeup_location_id=" + makeup_location_id + "&order_by=" + order_by + "&delivery_start_date=" + start_date, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
async getKnittedTrimOrders(accessToken, order_by) {
	let res = await axios.get(API_NAME + "/orders/knitted_trims?order_by=" + order_by, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
async getHatOrdersIncoming(accessToken, order_by) {
	let res = await axios.get(API_NAME + "/orders/hats?order_by=" + order_by + "&status=incoming", {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
async getHatOrdersInProgress(accessToken, order_by) {
	let res = await axios.get(API_NAME + "/orders/hats?order_by=" + order_by + "&status=inprogress", {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
async getHatOrdersCompleted(accessToken, order_by) {
	let res = await axios.get(API_NAME + "/orders/hats?order_by=" + order_by + "&status=completed", {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
async getCutSewPersonalisationOrders(accessToken, show_all = false) {
	let showAllParam = show_all ? 1 : 0;
	let res = await axios.get(API_NAME + "/orders/cut_sew_personalisation?show_all=" + showAllParam, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},



  async getPrintingCuttingReportData(accessToken, area, start_date, end_date) {
	
	let res = await axios.get(API_NAME + "/" + area + "?start_date=" + start_date + "&end_date=" + end_date + "&restrict_by_location=1", {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
		
	return res.data;
	},
	async getOffshoreReportData(accessToken, area, start_date, end_date) {
	
		let res = await axios.get(API_NAME + "/makeup_logs?area=" + area + "&start_date=" + start_date + "&end_date=" + end_date + "&restrict_by_location=1", {
			  headers: {
				Authorization: `Bearer ${accessToken}`
			  }
			});
			
		return res.data;
		},
	
	async getBundleReportData(accessToken, area, start_date, end_date, location_id, range_id) {
	
		let res = await axios.get(API_NAME + "/bundle_logs?start_date=" + start_date + "&end_date=" + end_date + "&area="+area + "&location_id=" + location_id + "&range_id=" + range_id, {
			  headers: {
				Authorization: `Bearer ${accessToken}`
			  }
			});
			
		return res.data;
		},
	async getProductivityReportData(accessToken, area, start_date, end_date, location_id, range_id, user_id, user_location_id) {
	
			let res = await axios.get(API_NAME + "/bundle_logs?bulk_scan=1&start_date=" + start_date + "&end_date=" + end_date + "&area="+area + "&location_id=" + location_id + "&range_id=" + range_id + "&user_id=" + user_id + "&user_location_id=" + user_location_id, {
				  headers: {
					Authorization: `Bearer ${accessToken}`
				  }
				});
				
			return res.data;
	},
	async getPrintingProcessedReportData(accessToken, start_date, end_date, makeup_location_id) {
	
		let res = await axios.get(API_NAME + "/orders/printing-processed-report?start_date=" + start_date + "&end_date=" + end_date + "&makeup_location_id=" + makeup_location_id + "&restrict_by_print_location_id=1", {
			  headers: {
				Authorization: `Bearer ${accessToken}`
			  }
			});
			
		return res.data;
		},
	
	async getDigitalPrintScheduler(accessToken, limit, order_by, start_date, end_date, scheduler_type, print_location_id, range_id, artwork_print_location_id) {
		let extras = ''
		if(scheduler_type == 'artwork')
		{
			extras = "&artwork_completed=0&print_location_id=" + artwork_print_location_id
		}
		if(scheduler_type == 'printing')
		{
			extras = "&artwork_printed_paper=0&print_location_id=" + print_location_id
		}
		if(scheduler_type == 'cutting')
		{
			extras = "&digital_print_cutting=0&print_location_id=" + print_location_id
		}
		
		let res = await axios.get(API_NAME + "/orders?printed=1&completed=0&limit=" + limit + "&order_by=" + order_by + "&range_id=" + range_id + "&with_quantities=1&delivery_start_date=" + start_date + "&delivery_end_date=" + end_date + extras, {
			  headers: {
				Authorization: `Bearer ${accessToken}`
			  }
			});
	  return res.data;
	},
  async getMakeupOrders(accessToken, makeup_location_id, limit, order_by, delivery_end_date) {
	// Removed fully_printed=1& on 6th June to see if multiply Short orders would appear
	  let res = await axios.get(API_NAME + "/orders?ready_for_makeup=1&with_bundles=1&completed=0&limit=" + limit + "&order_by=" + order_by + "&makeup_location_id=" +makeup_location_id + "&with_quantities=1&delivery_end_date=" + delivery_end_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getAwaitingMakeupOrders(accessToken, print_location_id, limit, order_by, delivery_start_date) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf,tblDesigns.requires_knitted_trim,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	let res = await axios.get(API_NAME + "/orders?limit=" + limit + "&printed=1&artwork_completed=1&completed=0&ready_for_makeup=0&with_knitted_trims=1&digital_print_cutting=1&ready_for_makeup_offshore=1&with_quantities=1&fields=" + selectFields + "&print_location_id=" + print_location_id+ "&order_by=" + order_by + "&delivery_start_date=" + delivery_start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
		  
		
    return res.data;
  },
  async getAwaitingMakeupMultiplyOrders(accessToken, print_location_id, limit, order_by, delivery_start_date) {
	//let selectFields = 'orders.artwork_new,orders.artwork_finished,orders.artwork_completed' 
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf,tblDesigns.requires_knitted_trim,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	
		  let res = await axios.get(API_NAME + "/orders?limit=" + limit + "&fully_printed=0&completed=0&ready_for_makeup=0&multiply_cutting=1&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&delivery_start_date=" + delivery_start_date, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
		
    return res.data;
  },
  async getPmsExportOrders(accessToken, limit, order_by) {
	
	let res = await axios.get(API_NAME + "/orders/pms_export?limit=" + limit + "&makeup_location_id=5&completed=0&with_quantities=1&order_by=" + order_by, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getCutSewOffshoreOrders(accessToken, limit, order_by) {
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	let res = await axios.get(API_NAME + "/orders/open?cutsew_cutting=0&limit=" + limit + "&fully_printed=0&location=offshore&exclude_socks=1&completed=0&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&delivery_start_date=2024-01-01&sent_offshore=1", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getCutSewIncomingOrders(accessToken, limit, order_by) {
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	let res = await axios.get(API_NAME + "/orders/open?limit=" + limit + "&fully_printed=0&cutting_location_id=0&location=offshore&exclude_socks=1&completed=0&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&delivery_start_date=2024-01-01&sent_offshore=1", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getCutSewInProgressOrders(accessToken, limit, order_by, cutting_location_id, cutsew_cutting, ready_for_cutsew_makeup) {
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	let res = await axios.get(API_NAME + "/orders?limit=" + limit + "&fully_printed=0&with_cutsew_cuttings=1&with_knitted_trims=1&location=offshore&cutting_location_id=" + cutting_location_id + "&cutsew_cutting=" + cutsew_cutting + "&ready_for_cutsew_makeup=" + ready_for_cutsew_makeup + "&exclude_socks=1&completed=0&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&delivery_start_date=2024-01-01&sent_offshore=1", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getCutSewMakeupInProgressOrders(accessToken, limit, order_by, cutting_location_id, cutsew_cutting, ready_for_cutsew_makeup) {
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	let res = await axios.get(API_NAME + "/orders?limit=" + limit + "&with_logs=1&fully_printed=0&with_knitted_trims=1&with_makeup_logs=1&location=offshore&cutting_location_id=" + cutting_location_id + "&cutsew_cutting=" + cutsew_cutting + "&ready_for_cutsew_makeup=" + ready_for_cutsew_makeup + "&exclude_socks=1&completed=0&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&delivery_start_date=2024-01-01&sent_offshore=1", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getCutSewCuttingsReport(accessToken, start_date, end_date, cutting_location_id) {
	
	let res = await axios.get(API_NAME + "/cutsew_cuttings/report?start_date=" + start_date + "&end_date=" + end_date + "&cutting_location_id=" + cutting_location_id, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  
  async getOffShoreMakeupInProgressOrders(accessToken, limit, order_by, makeup_location_id) {
	let selectFields = 'orders.*,tblClients.clientname,tblDesigns.requires_embroidery,tblDesigns.requires_embossing,tblDesigns.requires_silicon_stripes,tblDesigns.requires_knitted_trim,tblDesigns.requires_gps_pockets,orders.knitted_trim_complete,tblDesigns.requires_dtf' 
	
	let res = await axios.get(API_NAME + "/orders?limit=" + limit + "&makeup_location_id=" + makeup_location_id + "&with_knitted_trims=1&with_makeup_logs=1&multi_ready_for_makeup=1&location=offshore&exclude_socks=1&completed=0&with_quantities=1&fields=" + selectFields + "&order_by=" + order_by + "&delivery_start_date=2024-01-01", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  
  async getCompletedOrders(accessToken) {
	let res = await axios.get(API_NAME + "/orders?printed=1&completed=1&with_quantities=1", {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
async updateKnittedTrim(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/order_knitted_trims",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updatePrintPlannerNotes(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/print_planner_notes",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateOrder(accessToken, order_id, form_data) {
    let res = await axios.post(API_NAME + "/orders/" + order_id,  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateMultiOrder(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/orders/multi",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateEmbroideryRequestStrabane(accessToken, request_id, form_data) {
    let res = await axios.post(API_NAME + "/embroidery_requests_strabane/" + request_id,  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveEmbroideryRequestStrabane(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/embroidery_requests_strabane",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
 
  
  async updateDesign(accessToken, design_id, form_data) {
    let res = await axios.post(API_NAME + "/designs/" + design_id,  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateGarment(accessToken, garment_id, form_data) {
    let res = await axios.post(API_NAME + "/garments/" + garment_id,  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateGarmentOrders(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/garments/update_multi_orders",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateGarmentPricingDublin(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/garment_pricing_dublin",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveGarmentSize(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/garment_sizes",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async removeGarmentSize(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/garment_sizes/delete",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveGarmentFabric(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/garment_fabrics",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async deleteGarmentFabric(accessToken, garment_fabric_id, form_data) {
    let res = await axios.post(API_NAME + "/garment_fabrics/" + garment_fabric_id + '/delete',
	form_data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveDesignTrexCode(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/design_trex_codes",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveOrderTrexCode(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/order_trex_codes",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveOrderInitials(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/order_initials",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateOrderInitials(accessToken, form_data, id) {
    let res = await axios.post(API_NAME + "/order_initials/" + id,  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateOrderTrexCode(accessToken, form_data, id) {
    let res = await axios.post(API_NAME + "/order_trex_codes/" + id,  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  
  async saveBundles(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/bundles",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveInternalOrder(accessToken, form_data) {
    let res = await axios.post(API_NAME + "/internal_orders",  
         form_data
      ,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getStockOrders(accessToken) {
		let res = await axios.get(API_NAME + "/orders?stock=1", {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
	async getSingleOrder(accessToken, order_id, bundle_sets) {
		let res = await axios.get(API_NAME + "/orders/" + order_id + "?bundle_sets=" + bundle_sets, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
	async getSizes(accessToken) {
		let res = await axios.get(API_NAME + "/sizes", {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
			});
	return res.data;
	},
	async printingCuttingInputData(accessToken, form_data, area)
	{
		let apiEndPoint = API_NAME
		if(area == "paper")
		{
			apiEndPoint = API_NAME + "/printing_papers"
		}
		else if(area == "rolls")
		{
			apiEndPoint = API_NAME + "/printing_rolls"
		}
		else if(area == "cutting")
		{
			apiEndPoint = API_NAME + "/cuttings"
		}
		else if(area == "multiply_cutting")
		{
			apiEndPoint = API_NAME + "/multiply_cuttings"
		}
		else if(area == "cutsew_cutting")
		{
			apiEndPoint = API_NAME + "/cutsew_cuttings"
		}
		else if(area == "on_floor" || area == "off_floor" || area == "embroidery" || area == "silicon_stripes")
		{
			apiEndPoint = API_NAME + "/makeup_logs"
		}

		let res = await axios.post(apiEndPoint,  
         form_data
		,
		{
			headers: {
			Authorization: `Bearer ${accessToken}`
			}
		});
		return res.data;
	},
	async updateOrderPrintingSave(accessToken, form_data)
	{
		let apiEndPoint = API_NAME
		apiEndPoint = API_NAME + "/printing_saves"
		let res = await axios.post(apiEndPoint,  
         form_data
		,
		{
			headers: {
			Authorization: `Bearer ${accessToken}`
			}
		});
		return res.data;
	},
	
	async printingCuttingInputDataCompleteAll(accessToken, form_data, area)
	{
		let apiEndPoint = API_NAME
		if(area == "paper")
		{
			apiEndPoint = API_NAME + "/printing_papers/complete_all"
		}
		else if(area == "rolls")
		{
			apiEndPoint = API_NAME + "/printing_rolls/complete_all"
		}
		else if(area == "cutting")
		{
			apiEndPoint = API_NAME + "/cuttings/complete_all"
		}
		else if(area == "multiply_cutting")
		{
			apiEndPoint = API_NAME + "/multiply_cuttings/complete_all"
		}
		else if(area == "cutsew_cutting")
		{
			apiEndPoint = API_NAME + "/cutsew_cuttings/complete_all"
		}
		else if(area == "on_floor" || area == "off_floor" || area == "embroidery" || area == "silicon_stripes")
		{
			apiEndPoint = API_NAME + "/makeup_logs/complete_all"
		}


		let res = await axios.post(apiEndPoint,  
         form_data
		,
		{
			headers: {
			Authorization: `Bearer ${accessToken}`
			}
		});
		return res.data;
	},
	async bundleInputData(accessToken, form_data)
	{
		let apiEndPoint = API_NAME + "/bundles/update"
		
		let res = await axios.post(apiEndPoint,  
         form_data
		,
		{
			headers: {
			Authorization: `Bearer ${accessToken}`
			}
		});
		return res.data;
	},
	async productivityScanInputData(accessToken, form_data)
	{
		let apiEndPoint = API_NAME + "/bundle_logs"
		
		let res = await axios.post(apiEndPoint,  
         form_data
		,
		{
			headers: {
			Authorization: `Bearer ${accessToken}`
			}
		});
		return res.data;
	},
async sendOffshorePDFEmail(accessToken, form_data)
	{
		let apiEndPoint = API_NAME + "/orders/send_emails_with_pdfs"
		
		let res = await axios.post(apiEndPoint,  
         form_data
		,
		{
			headers: {
			Authorization: `Bearer ${accessToken}`
			}
		});
		return res.data;
	}

	

	
  
}